// src/components/Navbar/Navbar.jsx

import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  InputBase,
  Avatar,
  Badge,
  Stack,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const Navbar = ({
  title = "Dashboard",
  role = "Administrator",
  onDrawerToggle,
}) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  // MOCKED USER (replace with actual logged-in data)
  const user = JSON.parse(localStorage.getItem("user")) || {
    role,
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (e) => setAnchorEl(e.currentTarget);
  const closeMenu = () => setAnchorEl(null);
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const goToProfile = () => {
    closeMenu();

    const role = localStorage.getItem("role"); // ⬅️ get real role

    if (!role) return (window.location.href = "/");

    if (role === "admin") window.location.href = "/admin/admin-profile";
    else window.location.href = "/teacher/staff-profile";
  };

  const logout = () => {
    closeMenu();
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "transparent",
        boxShadow: "none",
        zIndex: (t) => t.zIndex.drawer - 1,
      }}
    >
      <Toolbar disableGutters sx={{ minHeight: { xs: 64, sm: 72 }, px: 0 }}>
        <Box
          sx={{
            width: "100%",
            borderRadius: 3,
            px: { xs: 1.5, sm: 3 },
            py: { xs: 1, sm: 1.25 },
            background:
              "linear-gradient(135deg, rgba(15,23,42,0.96), rgba(15,23,42,0.92))",
            border: "1px solid rgba(148,163,184,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          {/* LEFT - MENU + TITLE */}
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <IconButton
              edge="start"
              onClick={onDrawerToggle}
              sx={{
                display: { xs: "inline-flex", md: "none" },
                mr: 1,
                borderRadius: 2,
                bgcolor: "rgba(15,23,42,0.9)",
                border: "1px solid rgba(148,163,184,0.5)",
                "&:hover": { bgcolor: "rgba(15,23,42,1)" },
              }}
            >
              <MenuIcon sx={{ color: "#E5E7EB", fontSize: 22 }} />
            </IconButton>

            <Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: 18, sm: 20 },
                  background:
                    "linear-gradient(90deg, #ffffff 0%, #cbd5f5 40%, #818cf8 100%)",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  fontSize: 11,
                  mt: 0.2,
                  color: "rgba(148,163,184,0.85)",
                }}
              >
                Welcome back,{" "}
                <span style={{ color: "#E5E7EB" }}>{user.role}</span>
              </Typography>
            </Box>
          </Stack>

          {/* RIGHT - NOTIFICATION + PROFILE */}
          <Stack direction="row" alignItems="center" spacing={1.5}>
            {/* PROFILE BUTTON */}
            <Box
              onClick={openMenu}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: isMobile ? 0 : 2,
                px: isMobile ? 0.5 : 1.2,
                py: isMobile ? 0.2 : 0.5,
                borderRadius: 999,
                bgcolor: "rgba(15,23,42,0.85)",
                border: "1px solid rgba(55,65,81,0.9)",
                cursor: "pointer",
              }}
            >
              {/* Avatar — always visible */}
              <Avatar
                sx={{
                  width: 30,
                  height: 30,
                  bgcolor: "#4F46E5",
                  fontSize: 14,
                }}
              >
                {user.first_name?.[0] || "A"}
              </Avatar>

              {/* Hide name + role + arrow on mobile */}
              {!isMobile && (
                <>
                  <Box sx={{ overflow: "hidden" }}>
                    <Typography
                      sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#E5E7EB",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {user.first_name} {user.last_name}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 11,
                        color: "rgba(148,163,184,0.9)",
                      }}
                    >
                      {user.role}
                    </Typography>
                  </Box>

                  <KeyboardArrowDownIcon
                    sx={{ color: "#94A3B8", fontSize: 18 }}
                  />
                </>
              )}
            </Box>

            {/* MENU */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={closeMenu}
              PaperProps={{
                sx: {
                  mt: 1,
                  background: "rgba(15,23,42,0.98)",
                  border: "1px solid rgba(55,65,81,0.5)",
                  color: "#E5E7EB",
                },
              }}
            >
              <MenuItem onClick={goToProfile}>
                <AccountCircleIcon sx={{ mr: 1 }} /> Profile
              </MenuItem>
              <Divider sx={{ borderColor: "rgba(75,85,99,0.4)" }} />

              <MenuItem onClick={logout}>
                <LogoutIcon sx={{ mr: 1, color: "#EF4444" }} /> Logout
              </MenuItem>
            </Menu>
          </Stack>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
